import Alumni from '../assets/sponsors/AlumniOfficelight.png';
import AlumniDark from '../assets/sponsors/AlumniOffice.png';
import OSPE from '../assets/sponsors/OSPE.jpg';
import PEO from '../assets/sponsors/PEO.png';
import peodark from '../assets/sponsors/PEO_white.png';
import Nani from '../assets/sponsors/Nanis.png';
import nanidark from '../assets/sponsors/nanis_white.png';
import Longos from '../assets/sponsors/Longos.png';
import Troost_iLead from '../assets/sponsors/Troost_iLead.jpg';
import troostdark from '../assets/sponsors/troost_white.png';
import EMMO from '../assets/sponsors/EMMO_green.png';
import EMMOdark from '../assets/sponsors/EMMO_white.png';
import Panago from '../assets/sponsors/Panago.png';
import CRG from '../assets/sponsors/carly_dark.png';
import CRGdark from '../assets/sponsors/carly_white.png';
import Panagodark from '../assets/sponsors/Panagodark.png';
import MeetYou from '../assets/sponsors/meetyou.png';
import MeetYouDark from '../assets/sponsors/meetyoudark.png';
import Kailen from '../assets/sponsors/kailens-kreations.png';
import Kailendark from '../assets/sponsors/kailens-kreationsdark.png';
import UTSU from '../assets/sponsors/utsu.png';
import UTSUdark from '../assets/sponsors/utsudark.png';
import CityDental from '../assets/sponsors/city-dental.png';
import CityDentalDark from '../assets/sponsors/city-dentaldark.png';
import bikeshare from '../assets/sponsors/bikeshare.png';
import bikesharedark from '../assets/sponsors/bikesharedark.png';

export const sponsors = [
  {
    website: 'https://emmo.ca/',
    image: EMMO,
    darkimage: EMMOdark,
    scale: 0.82,
    rank: 'diamond',
    label: 'Diamond Sponsor: EMMO',
  },
  {
    website: 'https://citydentaltoronto.com/',
    image: CityDental,
    darkimage: CityDentalDark,
    scale: 0.82,
    rank: 'diamond',
    label: 'Diamond Sponsor: City Dental on Bay',
  },
  {
    website: 'https://alumni.engineering.utoronto.ca/',
    image: Alumni,
    darkimage: AlumniDark,
    scale: 0.88,
    rank: 'diamond',
    label: 'Diamond Sponsor: FASE Alumni',
  },
  {
    website: 'https://www.meetyoucafe.com/',
    image: MeetYou,
    darkimage: MeetYouDark,
    scale: 0.82,
    rank: 'gold',
    label: 'Gold Sponsor: MeetYou',
  },
  {
    website: 'https://carlyriangroup.com/',
    image: CRG,
    darkimage: CRGdark,
    scale: 0.82,
    rank: 'silver',
    label: 'Silver Sponsor: Carly Rian Consulting Group',
  },
  {
    website: 'https://www.panago.com/',
    image: Panago,
    darkimage: Panagodark,
    scale: 0.7,
    rank: 'silver',
    label: 'Silver Sponsor: Panago Pizza',
  },
  {
    website: 'https://www.peo.on.ca/',
    image: PEO,
    darkimage: peodark,
    scale: 0.82,
    rank: 'bronze',
    label: 'Bronze sponsor: PEO',
  },
  {
    website: 'https://www.nanisgelato.com/',
    image: Nani,
    darkimage: nanidark,
    scale: 0.82,
    rank: 'bronze',
    label: 'Bronze sponsor: Nani’s Gelato',
  },
  {
    website: 'https://ilead.engineering.utoronto.ca/',
    image: Troost_iLead,
    darkimage: troostdark,
    scale: 0.82,
    rank: 'bronze',
    label: 'Bronze Sponsor: Troost iLead',
  },
  {
    website: 'https://www.instagram.com/kailenskreations/',
    image: Kailen,
    darkimage: Kailendark,
    scale: 0.82,
    rank: 'bronze',
    label: 'Bronze Sponsor: Kailen’s Kreations',
  },
  {
    website: 'https://www.utsu.ca/',
    image: UTSU,
    darkimage: UTSUdark,
    scale: 0.8,
    rank: 'bronze',
    label: 'Bronze Sponsor: UTSU',
  },
  {
    website: 'https://bikesharetoronto.com/',
    image: bikeshare,
    darkimage: bikesharedark,
    scale: 0.8,
    rank: 'bronze',
    label: 'Bronze Sponsor: Bike Share Toronto',
  },
];
